import { useEffect } from "react";
import "./Explore.css"
import { useTranslation } from "react-i18next";

const ExploreCountries = ({BrandeData , homeData}) => {
  const { t } = useTranslation("News");
  const homeTitle = homeData?.data?.sections[1]?.title || "";
    const Clinet = homeData?.data?.sections[1]?.Posts[0]?.description || "";

  const dataBrands = Array.isArray(BrandeData?.data) ? BrandeData?.data : [];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-visible");
          } else {
            entry.target.classList.remove("animate-visible");
          }
        });
      },
      { threshold: 0.2 } // Trigger animation when 20% of the section is visible
    );

    const sections = document.querySelectorAll(".animate-section");
    sections.forEach((section) => observer.observe(section));

    return () => observer.disconnect();
  }, []);
  return (
    <>
    <div id="partners" ></div>
    <div className="bg-[#fff] ">
      <div className="w-full h-auto bg-[#fff] flex flex-col gap-6 items-center lg:pt-5 pb-24 lg:py-24  px-4 ">
      {/* Title Section */}
      <div className="text-center">
        <span className="text-[23px] text_bold_Bukra leading-[45.5px] text-[#0d6b70] block animate-section opacity-0 transition-opacity duration-1000">
          {homeTitle}
        </span>
        <div className="lg:w-[776px] text-center justify-start 29LT_Bukra text-base font-medium  text-[#667680] mt-4">
          {Clinet}
        </div>
      </div>

      {/* Partners Grid */}
      <div className="flex flex-wrap justify-center gap-8 w-full max-w-[1100px] xl:scale-[92%] animate-section opacity-0 transition-opacity duration-1000">
        {/* Partner Card */}
        {dataBrands.map((brand) => (
              <div
                key={brand.id}
                className="w-[250px] h-[120px] cards flex flex-col items-center p-6 gap-16 overflow-hidden border-2 border-[#A5FCC6]"
              >
            <div
              className="overflow-hidden"
             
            >
              <img src={brand?.image[0]?.original} className="w-full h-full"/>
            </div>
          </div>
        ))}
      </div>

      </div>
    </div>
    
    </>
  );
};

export default ExploreCountries;
